var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 512 512",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m393.3 161.33l-58.768-84.892a48.09 48.09 0 0 0-38.775-20.673l-111.527-1.6H184c-57.579 0-101.757 9.631-130.21 56.634C27.3 154.551 16 229.08 16 360v16h36.557L29.024 496h32.61l23.533-120H96a99.521 99.521 0 0 0 70.088-27.992c16.979-16.246 29.226-38.472 35.419-64.274l.056-.232L229.006 152h-32.69l-25.979 124.488C162.425 309.168 138.766 344 96 344H48.06c.869-113.266 11.182-180.419 33.105-216.634c18.4-30.4 45.295-41.191 102.724-41.206l111.408 1.6a16.026 16.026 0 0 1 12.925 6.891L374.7 190.67l89.3 14.884v16.959l-14.892 79.421c-4.395 23.441-11.908 35.249-42.718 38.95l-126.306 21.609L279.249 496h32l.667-106.493l98.7-16.9c22.36-2.749 38.857-9.955 50.426-22.023c9.89-10.318 15.909-23.5 19.519-42.752L496 225.487v-47.041Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.f2035c22a0474fc5024effbc3abffd13.svg";
export { ForwardRef as ReactComponent };